<template>
  <div>
    <headers />
    <el-breadcrumb
      separator-class="el-icon-arrow-right"
      style="margin:27px auto"
      class="containers breadcrumb"
    >
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/information' }">资讯中心</el-breadcrumb-item>
      <el-breadcrumb-item>{{details.title}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="infordetails containers">
      <h3>{{details.title}}</h3>
      <div class="small">
        <span>
          <i class="el-icon-time"></i>
          {{details.create_time}}
        </span>
        <span>
          <i class="el-icon-view"></i>
          {{details.count}}
        </span>
      </div>
    </div>
    <div class="article containers">

         <p v-html="details.content"></p>

         <img :src="details.image" alt="" srcset="">
       
    </div>
    <footers />
  </div>
</template>

<script>
import headers from "@/components/header.vue";
import footers from "@/components/footer.vue";
import { Pagination, Breadcrumb, BreadcrumbItem } from "element-ui";
import utilFile from "@/ace/ace.js";
export default {
  components: {
    headers,
    footers,
    [Pagination.name]: Pagination,
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem
  },
  data(){
      return{
          details:{}
      }
  },
  methods: {
    informationfunc() {
      var data = {
        article_id: this.$route.query.id
      };
      data = utilFile.encrypt(JSON.stringify(data));
      this.$axios({
        method: "post",
        url: `/index/article.detail?parameter=${data}`,
        data: {},
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        
        if (res.data.data != undefined) {
          let totaldata = JSON.parse(utilFile.decrypt(res.data.data));
          this.details = totaldata;
        }
      });
    }
  },
  mounted() {
    this.informationfunc();
  }
};
</script>

<style scoped>
.infordetails {
  background-color: #ffffff;
  overflow: hidden;
  box-sizing: border-box;
  padding: 0 40px;
}

.infordetails h3 {
  text-align: center;
  font-size: 20px;
  color: #000000;
  margin-top: 40px;
  margin-bottom: 20px;
  font-weight: bold;
}

.infordetails .small {
  text-align: center;
  font-size: 14px;
  color: #888888;
  padding-bottom: 30px;
  border-bottom: 1px solid #edf1f2;
  margin-bottom: 42px;
}

.infordetails .small span {
  margin: 0 12px;
}

.article{
    background-color: #FFF;
    margin-bottom: 60px;
    padding-bottom: 110px;
    text-align: left;
    box-sizing: border-box;
    padding: 0 40px;
}

.article img{
    width: 724px;
    margin:35px auto;
}

.small span i{
  color:#000;
}
</style>